/**
 * Data de "hoje" no fuso de Brasília (America/Sao_Paulo), em ISO `YYYY-MM-DD`.
 *
 * Usa `Intl` com locale en-CA (que formata como AAAA-MM-DD) e timeZone fixo — evita o bug de usar
 * `new Date().toISOString()` (UTC), que entre 21h e a meia-noite já mostra o dia seguinte e poderia
 * errar a data da virada de vigência na tela. A resolução de vigência no backend já é em Brasília.
 */
export function brToday(): string {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: "America/Sao_Paulo",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(new Date());
}
